import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-intergrade-software',
  templateUrl: './intergrade-software.component.html',
  styleUrls: ['./intergrade-software.component.scss']
})
export class IntergradeSoftwareComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
